import React from 'react'
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  DialogTitle
} from '@material-ui/core'
import ProgressButton from 'components/ProgressButton'

// Shown when createConferenceAdmin answers { alreadyAssigned: true, conferences: [...] } — the
// email already belongs to a conference user. Confirming re-submits the same payload with
// force: true so the backend links the existing account to the current conference too.
const DuplicateAssignmentDialog = ({ conferences = [], inProgress, onCancel, onConfirm }) => (
  <Dialog open={conferences.length > 0} maxWidth="xs" fullWidth>
    <DialogTitle>User Already Assigned</DialogTitle>
    <DialogContent>
      <DialogContentText style={{ marginBottom: '12px' }}>
        This user is already assigned to the following active conference(s):
      </DialogContentText>
      <Box
        style={{
          border: '1px solid #e2e8f0',
          borderRadius: 8,
          overflow: 'hidden',
          marginBottom: '16px'
        }}>
        {conferences.map((conf, index) => {
          const role = conf.role ?? 'admin'
          const isOwner = role === 'owner'
          return (
            <Box
              key={conf.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 14px',
                backgroundColor: index % 2 === 0 ? '#f8fafc' : '#ffffff',
                borderBottom: index < conferences.length - 1 ? '1px solid #e2e8f0' : 'none'
              }}>
              <Typography style={{ fontSize: 14, fontWeight: 500, color: '#1e293b' }}>
                {conf.confName}
              </Typography>
              <Chip
                label={role.charAt(0).toUpperCase() + role.slice(1)}
                size="small"
                style={{
                  backgroundColor: isOwner ? '#dbeafe' : '#f1f5f9',
                  color: isOwner ? '#1d4ed8' : '#475569',
                  fontWeight: 600,
                  fontSize: 11,
                  height: 22
                }}
              />
            </Box>
          )
        })}
      </Box>
      <DialogContentText>Do you want to assign them to this conference as well?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={inProgress}>
        Cancel
      </Button>
      <ProgressButton
        label="Continue"
        inProgress={inProgress}
        disabled={inProgress}
        onClick={onConfirm}
      />
    </DialogActions>
  </Dialog>
)

export default DuplicateAssignmentDialog
